import { useEffect, useState } from 'react'
import { GoogleMap, MarkerF, CircleF, useJsApiLoader } from "@react-google-maps/api";
import { MapProps } from '../../constants/mapMode';


const GoogleMapsComponent = ({ zoom, containerStyle, disable, zoomControl, draggable, clickableIcons, lat, lang, }: MapProps) => {
    const [currentLocation, setCurrentLocation] = useState<any>(null);
    const [libraries] = useState<any>(['places']);

    useEffect(() => {
        if (lat && lang) {
            setCurrentLocation({ lat: parseFloat(lat), lng: parseFloat(lang) });
        }
    }, [lat, lang])

    const mapOptions = {
        disableDefaultUI: disable, // This will remove all default UI controls
        zoomControl: zoomControl, // This will specifically remove the zoom control
        draggable: draggable, // Disable dragging the map
        clickableIcons: clickableIcons, // Disable clicking on map icons
        disableDoubleClickZoom: disable,
        styles: [
            {
                featureType: 'poi',
                elementType: 'labels',
                stylers: [
                    { visibility: 'off' },
                ],
            },
        ],
    };

    const { isLoaded } = useJsApiLoader({
        id: "google-map-script",
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_KEY || "",
        libraries,
    });

    /**Header search location getFormattedAddress Function */
    const geocoder: any = isLoaded ? new window.google.maps.Geocoder() : '';

    const getFormattedAddress = (lat: any, lng: any) => {
        geocoder.geocode({ location: { lat, lng } }, (results: any, status: any) => {
            if (status) {
                if (results[0]) {
                    // dispatch(setLocationName(results[GLOBAL_CONSTANTS.INITIAL_VALUES.ZERO_INT]?.formatted_address));
                }
            }
        });
    }

    return isLoaded ? (
        <>
            <GoogleMap
                id={'google-map-script'}
                mapContainerStyle={containerStyle}
                zoom={zoom}
                center={currentLocation}
                options={mapOptions}
            >
                <CircleF
                    center={currentLocation}
                    options={{
                        fillColor: '#178FFF', // Fill color with opacity
                        strokeColor: 'rgba(79, 139, 255, 0.60)', // Border color
                        strokeOpacity: 0.8, // Border opacity
                        strokeWeight: 2, // Border width
                        fillOpacity: 0.1, // Fill opacity
                    }}
                />
                {currentLocation && (
                    <MarkerF
                        position={currentLocation}
                        draggable={true}
                        shape={{ coords: [17, 17, 18], type: "circle" }}
                        onDragEnd={
                            (e: any) => {
                                setCurrentLocation({ lat: e.latLng.lat(), lng: e.latLng.lng() });
                                getFormattedAddress(e?.latLng?.lat(), e?.latLng?.lng());
                            }}
                    />
                )}
            </GoogleMap >
        </>
    ) : (<></>)
};

export default GoogleMapsComponent;